import { GlobalPlayerProvider } from "@bandwith/recordings";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./lib/auth";
import { queryClient } from "./lib/queryClient";
import { router } from "./router";

function App() {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <GlobalPlayerProvider>
            <RouterProvider router={router} />
          </GlobalPlayerProvider>
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(<App />);
}
